import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL + "/api/";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// A separate axios client for refreshing token (prevents loops)
const refreshClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (response) => response,

  async (error) => {
    const originalRequest = error.config;

    // Skip interceptor for logout
    if (originalRequest._isLogoutRequest) {
      return Promise.reject(error);
    }

    // If unauthorized and not retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // try to refresh access token
        await refreshClient.post("users/dispatcher/token/refresh/");

        // retry original request
        return axiosInstance(originalRequest);
      } catch (err) {
        // Refresh failed → user must login again
        localStorage.removeItem("user");

        // Hard redirect to login
        window.location.href = "/";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
